import { Checkbox, TablePagination, TableCell } from '@mui/material';
import { useSelector } from 'react-redux';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { makeStyles } from '@mui/styles';
import ThreeDotMenu from './ThreeDotMenu';
import {
  CustomTableCellForBody,
  CustomTableCellForNoData,
  CustomTableView,
} from '../../../components/UI/CustomTableView';
import defaultCard from '../../../assets/defaultCard.png';
import useUserTimeZone, { getTimeZoneAbbreviation } from '../../../hooks/useUserTimeZone';
import useSortHook from '../../../hooks/useSortHook';

const tableCellPStyle = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '250px',
  maxHeight: '100px',
};

const TableViewInvoice = ({
  data,
  paginationData,
  onPageChange,
  onRowsPerPageChange,
  onEdit,
  onDisplay,
  onDelete,
  onSelectedChange,
  selectedAccount,
  onChangeLog,
}) => {
  const { user } = useSelector((state) => state.login);
  const { handleSort, newSortData, sortState } = useSortHook(data, ['purchaseDate']);
  const { expiryCheck, formatDate } = useUserTimeZone();
  const handleDoubleClick = (event, data) => {
    if (event.detail === 2) {
      onDisplay(data);
    }
  };

  const headData = [
    'Actions',
    'Code',
    'Bill Number',
    'Store Name',
    'Event',
    'No of Item',
    'Purchase amount',
    'Warranty item',
  ];

  const amountSym = user.country === 'United States' ? '$' : '₹';

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '48px' }}>
        {selectedAccount?.length > 0 ? (
          <div>
            <span>
              <b>{selectedAccount?.length}</b> selected
            </span>
          </div>
        ) : (
          <span />
        )}

        <TablePagination
          component="div"
          size="small"
          count={paginationData?.total ?? 0}
          rowsPerPageOptions={[10, 15, 25, 50, 100]}
          rowsPerPage={paginationData?.limit ?? 15}
          page={paginationData.page - 1}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
        />
      </div>
      <TableContainer sx={{ maxHeight: 600 }}>
        <CustomTableView
          isSort
          sort={{
            order: sortState.order,
            orderBy: sortState.orderBy,
            createSortHandler: handleSort,
            sortHeadMap: ['', 'code', 'billNumber', 'store', 'event.name', '', ''],
          }}
          headData={headData}
        >
          {data.length === 0 && (
            <CustomTableCellForNoData message={`There are no recorded bills for you. Kindly add a new one.`} />
          )}
          {newSortData?.map((e, index) => {
            // const expiryCheckFlag = e?.warrantyDetailsExpireDate ? expiryCheck(e.warrantyDetailsExpireDate) : false;
            const totalItemsCount = e?.lineItems?.length;
            const totalItemsAmount = e?.lineItems?.reduce((acc, curr) => acc + curr?.grossAmount, 0);
            const totalItemsWarranty = e?.lineItems?.filter((eX) => eX?.isWarranty)?.length;
            return (
              <TableRow key={index} onClick={(ev) => handleDoubleClick(ev, e)}>
                <CustomTableCellForBody align="center" padding="checkbox">
                  <div style={{ display: 'flex' }}>
                    {/* <Checkbox checked={selectedAccount.includes(e._id)} onChange={() => onSelectedChange(e._id)} /> */}
                    <ThreeDotMenu
                      onChangeLog={() => onChangeLog(e)}
                      data={e}
                      onEdit={(flag) => {
                        if (flag) {
                          onDisplay(e);
                        } else {
                          onEdit(e);
                        }
                      }}
                      onDelete={() => onDelete(e)}
                    />
                  </div>
                </CustomTableCellForBody>
                <CustomTableCellForBody align="center">
                  <p style={tableCellPStyle}>{e?.code}</p>
                </CustomTableCellForBody>
                <CustomTableCellForBody align="left">
                  <p style={tableCellPStyle}>{e?.billNumber}</p>
                </CustomTableCellForBody>
                <CustomTableCellForBody align="left">
                  <p style={tableCellPStyle}>{e?.store}</p>
                </CustomTableCellForBody>
                <CustomTableCellForBody align="left">
                  <p style={tableCellPStyle}>{e?.event?.name}</p>
                </CustomTableCellForBody>
                <CustomTableCellForBody align="left">
                  <p style={tableCellPStyle}>{totalItemsCount} Nos</p>
                </CustomTableCellForBody>
                <CustomTableCellForBody align="left">
                  <p style={tableCellPStyle}>{`${amountSym} ${totalItemsAmount}`}</p>
                </CustomTableCellForBody>
                <CustomTableCellForBody align="left">
                  <p style={tableCellPStyle}>{totalItemsWarranty} Nos</p>
                </CustomTableCellForBody>
              </TableRow>
            );
          })}
        </CustomTableView>
      </TableContainer>
    </>
  );
};

export default TableViewInvoice;
